import React from "react";

import AppState from "./model/AppState";
import { Snackbar } from "@material-ui/core";
import BotaoVoltar from "./components/BotaoVoltar";
import LogUtil from "./util/LogUtil";
import Rodape from "./components/Rodape";
import C5CompraModel from "./model/C5CompraModel";
import C5UsuarioDAO from "./dataAccess/C5/C5UsuarioDAO";
import DataUtil from "./util/DataUtil";
import UsuarioModel from "./model/UsuarioModel";
import NavegadorUtil from "./util/NavegadorUtil";
import QueryString from "query-string";
import LojaModel from "./model/LojaModel";
import C5CompraItemModel from "./model/C5CompraItemModel";
import PedidoItem from "./components/PedidoItem";
import { RouteComponentProps, withRouter } from "react-router-dom";
import Carregando from "./components/Carregando";
import CompraCacheModel from "./model/CompraCacheModel";
import ProxyCacheDAO from "./dataAccess/Proxy/ProxyCacheDados";
import CompraProdutoCacheModel from "./model/CompraProdutoCacheModel";
import ProdutoModel from "./model/ProdutoModel";
import C5ProdutoDAO from "./dataAccess/C5/C5ProdutoDAO";
import ObaPedidoDAO from "./dataAccess/Oba/ObaPedidoDAO";
import C5LojaDAO from "./dataAccess/C5/C5LojaDAO";

type PedidosState = {
  pedidos: C5CompraModel[];
  pedido?: C5CompraModel;
  carregando: boolean;
  concluido: boolean;
  dadosAdicionais?: CompraCacheModel;
  lojas: LojaModel[];
};

interface IPedidosProps extends RouteComponentProps {}

class Pedidos extends React.Component<IPedidosProps, PedidosState> {
  constructor(props: IPedidosProps) {
    super(props);

    this.getStatusIcone = this.getStatusIcone.bind(this);
    this.adicionarTudo = this.adicionarTudo.bind(this);
    this.comprarNovamente = this.comprarNovamente.bind(this);

    this.state = {
      pedidos: [],
      lojas: [],
      carregando: true,
      concluido: false,
    };
  }

  getStatusIcone(status: string): string {
    const baseStatusIcone: string = NavegadorUtil.getUrl(
      "/assets/images/icons/status"
    );
    switch (status) {
      case "enviado":
        return `${baseStatusIcone}/arrow-up-circle.svg`;
      case "aprovado":
        return `${baseStatusIcone}/thumbs-up.svg`;
      case "retirado":
        return `${baseStatusIcone}/check-circle.svg`;
      case "cancelado":
      case "cancelada":
        return `${baseStatusIcone}/ban-solid.svg`;
      default:
        return `${baseStatusIcone}/arrow-up-circle.svg`;
    }
  }

  async componentDidMount(): Promise<void> {
    LogUtil.logPage("Pedidos");
    const usuario: UsuarioModel | null = AppState.getUsuarioLogado();
    let allProms: any = [];
    if (usuario) {
      const lojas: LojaModel[] = await C5LojaDAO.getInstance().getAll();

      this.setState({ lojas });

      C5UsuarioDAO.getInstance()
        .buscaHistoricoCompras(usuario.clienteId)
        .then((compras: C5CompraModel[]) => {
          compras.forEach((c: C5CompraModel) => {
            allProms.push(
              ProxyCacheDAO.getInstance()
                .getCompraDetalhes(c.compraId)
                .then((r) => {
                  let retiradaTipo: string = "";
                  if (r) {
                    retiradaTipo = r.descricaoAgendamento;
                    c.descricaoRetirada = r.mensagemEntrega;
                    c.lojaId = r.lojaId;
                  }
                  c.mensagemRetirada = retiradaTipo;
                })
            );

            allProms.push(
              ObaPedidoDAO.getInstance()
                .getPedidoStatus(c)
                .then((r) => {
                  c.status = r.status;
                  c.statusId = r.statusId;
                  c.statusAtualizacao = r.statusAtualizacao;
                })
            );
          });

          let query: any = QueryString.parse(this.props.location.search);

          if (query && query.pedidoId && query.pedidoId.length > 0) {
            const pedido: C5CompraModel | undefined = compras.find(
              (p) => +p.compraId === +query.pedidoId
            );
            this.setState({ pedido });
          }

          Promise.all(allProms)
            .then(() => {
              this.setState({ pedidos: compras, carregando: false, concluido: true, });
            })
            .catch(() => {
              this.setState({ pedidos: compras, carregando: false, concluido: true, });
            });
        });
    }

    let query: any = QueryString.parse(this.props.location.search);

    if (query && query.pedidoId && query.pedidoId.length > 0) {
      ProxyCacheDAO.getInstance()
        .getCompraDetalhes(query.pedidoId)
        .then((r) => {
          this.setState({ dadosAdicionais: r });
        });
    }
  }

  async adicionarTudo(evt: any): Promise<void> {
    evt.preventDefault();
    const proms: any = [];
    const loja: LojaModel | null = AppState.getLojaSelecionada();
    this.setState({ carregando: true });
    const { pedido } = this.state;

    if (loja && pedido) {
      for (const item of pedido.produtos) {
        let qtdItem: number = item.quantidade;
        while (qtdItem > 0) {
          const prod: ProdutoModel | null = await C5ProdutoDAO.getInstance().getById(
            item.produtoId,
            loja.lojaId
          );
          if (prod) {
            proms.push(await AppState.addCarrinhoItem(prod, item.notas));
            qtdItem--;
          }
        }
      }
    }

    Promise.all(proms)
      .then(() => {
        NavegadorUtil.alerta(
          this,
          "Itens adicionados ao carrinho com sucesso."
        );
        this.setState({ carregando: false });
      })
      .catch(() => {
        NavegadorUtil.alerta(
          this,
          "Alguns itens não foram adicionados por não estarem em estoque.  Favor revisar o carrinho."
        );
        this.setState({ carregando: false });
      });
  }

  comprarNovamente(): void {
    const { pedido } = this.state;

    const loja = AppState.getLojaSelecionada();

    if (loja) {
      pedido?.produtos.map(async p => {
        const prod = await C5ProdutoDAO.getInstance().getById(p.produtoId, loja.lojaId);
        if (prod) {
          const prodSearch = await C5ProdutoDAO.getInstance().getBuscaProdutos(prod.sku, "", loja.lojaId);
          if (prodSearch &&  prodSearch.length === 1) {
              await AppState.addCarrinhoItem(prodSearch[0]);
          }
        }
      });
      NavegadorUtil.alerta(this, "Itens adicionados ao carrinho.");
    }
  }

  render(): any {
    const { lojas, pedidos, carregando, dadosAdicionais, pedido, concluido } = this.state;

    if (carregando) {
      return (
        <section className="lists">
          <div className="header">
            <BotaoVoltar titulo="Pedidos"></BotaoVoltar>
            <Carregando exibir={carregando} concluido={concluido}></Carregando>
          </div>
        </section>
      );
    }

    if (pedido) {
      let alerta: any = AppState.getAlerta();
      let query: any = QueryString.parse(this.props.location.search);
      const pedidoTitulo: string = `Pedido #${query.pedidoId}`;
      let loja: LojaModel | null = AppState.getLojaSelecionada();

      if (pedido.lojaId) {
        const lojaCompra: LojaModel | undefined = lojas.find(l => pedido.lojaId && (+l.lojaId === +pedido.lojaId));

        if (lojaCompra) {
          loja = lojaCompra;
        }
      }

      let retiradaTipo: string = "";
      let mensagemRetirada: string =
        "Caso algum produto não estiver disponível, substituir por produto similar.";

      if (dadosAdicionais) {
        mensagemRetirada = dadosAdicionais.textoAlternativo;
        retiradaTipo = dadosAdicionais.descricaoAgendamento;
      }

      for (const item of pedido.produtos) {
        if (dadosAdicionais) {
          const produto:
            | CompraProdutoCacheModel
            | undefined = dadosAdicionais.produtos.find(
            (p) => p.produtoId === item.produtoId
          );
          if (produto) {
            item.notas = produto.notas;
            item.precoUnitario = produto.precoUnitario;
            item.precoUnitarioDesconto = produto.precoUnitarioDesconto;
          }
        }
      }

      if (loja) {
        let statusConcluido: boolean = pedido.status === "Entregue";
        return (
          <section className="lists orders">
            <div className="header">
              <BotaoVoltar titulo={pedidoTitulo}></BotaoVoltar>
            </div>
            <div className="order-status">
              <div className="status">
                <div className="circle">
                  <img
                    src={this.getStatusIcone("enviado")}
                    alt="Enviado"
                    className="active"
                  />
                  <p>Pedido enviado</p>
                </div>
                {statusConcluido && (
                  <>
                    <div className="circle">
                      <img
                        src={this.getStatusIcone("aprovado")}
                        alt="Aprovado"
                        className="active"
                      />
                      <p>Pagamento Aprovado</p>
                    </div>
                    <div className="circle">
                      <img
                        src={this.getStatusIcone("retirado")}
                        alt={pedido.status}
                        className="active"
                      />
                      <p>{pedido.status}</p>
                    </div>
                  </>
                )}
                {!statusConcluido && (
                  <>
                    <div className="circle">
                      <img
                        src={this.getStatusIcone("pendente")}
                        alt="Pendente"
                      />
                      <p>Pagamento Pendente</p>
                    </div>
                    <div className="circle">
                      <img
                        src={this.getStatusIcone("cancelado")}
                        alt={
                          pedido.status === "Aprovada"
                            ? "Retirada"
                            : pedido.status
                        }
                        className=""
                      />
                      <p>
                        {pedido.status === "Aprovada"
                          ? "Retirada"
                          : pedido.status}
                      </p>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="store-pickup">
              <p className="title">Loja:</p>
              <p>
                {loja.nome} - {loja.logradouro}, {loja.numero} - {loja.bairro},{" "}
                {loja.cidade} - {loja.uf}, {loja.cep}
              </p>
              <br />
              <p className="title">Caso o produto não esteja disponível:</p>
              <p>{mensagemRetirada}</p>
              <br />
              {retiradaTipo && retiradaTipo.length > 0 && (
                <>
                  <p className="title">{pedido.descricaoRetirada}:</p>
                  <p>{retiradaTipo}</p>
                </>
              )}
            </div>
            <ul className="items">
              {pedido.produtos.map((item: C5CompraItemModel) => (
                <PedidoItem
                  item={item}
                  loja={loja}
                  key={item.produtoId}
                  parent={this}
                ></PedidoItem>
              ))}
            </ul>
            <div className="total">
              <p className="total">
                Total<span>{`R$ ${pedido.totalCompra.toFixed(2).replace(".", ",")}`}</span>
              </p>
            </div>
            <div>
              <button onClick={this.comprarNovamente} className="main-button sec">
                Comprar novamente
              </button>
            </div>
            {alerta && (
              <Snackbar
                open={alerta.exibirModal}
                className="info"
                transitionDuration={1000}
                onClose={() => AppState.fecharAlerta(this)}
                autoHideDuration={6000}
                ContentProps={{ "aria-describedby": "message-id" }}
                message={<span id="message-id">{alerta.mensagem}</span>}
              />
            )}
            {pedido.produtos.length > 0 && false && (
              <button className="main-button" onClick={this.adicionarTudo}>
                Pedir novamente
              </button>
            )}

            <Rodape parent={this} ativo="Carrinho"></Rodape>
            <Carregando exibir={carregando} concluido={concluido}></Carregando>
          </section>
        );
      }
    }

    let alerta: any = AppState.getAlerta();
    return (
      <section className="lists orders">
        <div className="header">
          <BotaoVoltar titulo="Pedidos"></BotaoVoltar>
        </div>
        {pedidos &&
          pedidos.length > 0 &&
          pedidos.map((compra: C5CompraModel) => {
            let statusProblema: boolean =
              compra.status === "Cancelado" ||
              compra.status === "Cancelada" ||
              compra.status === "Problemas" ||
              compra.status === "Problemas";
            return (
              <div
                className="order"
                key={compra.compraId}
                onClick={() =>
                  NavegadorUtil.redirect(
                    `/pedido?pedidoId=${compra.compraId}`,
                    this.props.history
                  )
                }
              >
                <p className="title">Pedido n&#186; {compra.compraId}</p>
                <p>
                  <strong>
                    R$ {compra.totalCompra.toFixed(2).replace(".", ",")}
                  </strong>
                </p>
                <p>
                  Compra efetuada em{" "}
                  <strong>{DataUtil.getDMA(compra.data)}</strong>
                </p>
                <p>{compra.mensagemRetirada}</p>
                {statusProblema && (
                  <p className="status danger">{compra.status}</p>
                )}
                {!statusProblema && <p className="status">{compra.status}</p>}
              </div>
            );
          })}
        {pedidos && pedidos.length === 0 && (
          <div className="empty-cart">
            <p>Nenhum pedido registrado para este usuário</p>
            <p
              onClick={() =>
                NavegadorUtil.redirect("/home", this.props.history)
              }
            >
              <strong>Voltar para a página inicial</strong>
            </p>
          </div>
        )}
        {alerta && (
          <Snackbar
            open={alerta.exibirModal}
            className="info"
            transitionDuration={1000}
            onClose={() => AppState.fecharAlerta(this)}
            autoHideDuration={6000}
            ContentProps={{ "aria-describedby": "message-id" }}
            message={<span id="message-id">{alerta.mensagem}</span>}
          />
        )}
        <Rodape parent={this} ativo="Carrinho"></Rodape>
      </section>
    );
  }
}

export default withRouter(Pedidos);
